import {
    useMemo,
} from 'react'

import useRequestTable from 'app/hooks/useRequestTable'
import {
    RequestKeys,
} from 'app/hooks/useRequest'

import request from 'app/requests/Container/Container.requests'
import {
    LoggerContainerInfo,
} from '../containers.types'

const useGetLoggerContainerInformationBySerialNumber = (
    serialNumber: string,
) => {
    const {
        data,
        onParamsChange,
        loadData,
        isDataReady,
        isError,
        error,
        isFetching,
        invalidate,
    } = useRequestTable<{data: LoggerContainerInfo[]}>({
        config: request[RequestKeys.getLoggerContainerInformation],
        params: {
            serialNumber,
        },
        key: RequestKeys.getLoggerContainerInformation,
    })

    const dataFormated = useMemo(() => {
        return (data?.data || []) as LoggerContainerInfo[]
    }, [data])

    return {
        data: dataFormated,
        onParamsChange,
        loadData,
        isDataReady,
        isError,
        error,
        isFetching,
        invalidate,
    }
}

export default useGetLoggerContainerInformationBySerialNumber
